import Link from '../../views/AssessmentHelp';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      // console.log(value);
      window.close();
    }
  };
};

const AssesmentHelp = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default AssesmentHelp;



// WEBPACK FOOTER //
// ./src/components/container/AssesmentHelp/index.js